import { render, staticRenderFns } from "./GradesPage.vue?vue&type=template&id=28dfd06e"
import script from "./GradesPage.vue?vue&type=script&lang=js"
export * from "./GradesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports